module.exports = {
    ChanceBoard: {
        department: '部门',
        sales_user_id: '销售员',
        query: '查询',
        Show_chance_distribution: '显示机会分布',
        Show_sales_funnel: '显示漏斗数据',
        chance_cnt: '机会数量',
        win_amount: '成单金额',
        win_number: '成单数',
        fail_number: '失败数',
        level_rise: '级别上升',
        level_decline: '级别下降',
        follow_number: '跟进客户',
        create_chance: '创建机会',
        created_in_30_days: '30日创建',
        no_follow_in_30_days: '30日未跟进',
        no_follow_in_60_days: '60日未跟进',
        no_level_up_30_days: '30日无提升',
        has_quote_in_30_days: '30日有报价',
        has_contract_in_30_days: '30日有合同',

    },
    quote: {
        select_contacts: '选择联系人',
        effective_to: '有效期至',
        select_quotation_template: '选择报价模板',
        preview_template: '预览模板',
        add_line: '添加商品行',
        trade_name: '商品名称',
        unit: '单位',
        standard_price: '标准价',
        minimum_price: '最低价',
        tax_rate: '税率',
        sales_price: '销售价',
        discount_ratio: '折扣比例%',
        number: '数量',
        remark: '商品名称备注',
        select_item: '选择商品名称',
        quote_remark: '报价备注',
        tax_amount: '税额',
        total_amount_including_tax: '含税总金额',
        amount_not_taxed: '未税金额',
        template_extension_variable: '模板扩展变量',
        please_select: '请选择',
        submit: '提交',
        price_tips: '当前价格低于最低价，需审核',
        template_preview: '模板预览',
        template_tips: '请选择模板',
        get_failed: '获取失败',
        failed_to_get_product_catalog: '获取产品目录失败',
        contact_cannot_be_empty: '联系人不能为空',
        valid_until_cannot_be_empty: '有效期至不能为空',
        commodity_data_cannot_be_empty: '商品数据不能为空',
        quotation_template_cannot_be_empty: '报价模板不能为空',
        failed_to_get_quotation_template: '获取报价模板失败',
        failed_to_get_contact: '获取联系人失败',
        failed_to_get_product: '获取商品失败',
        quotation_data_cannot_be_empty: '报价数据不能为空',
        submission_failed: '提交失败',
        submitted_successfully: '提交成功',
        the: '第',
        product_name_cannot_be_empty: '个商品名称不能为空',
        unit_cannot_be_empty: '个单位不能为空',
        market_price_cannot_be_empty: '个标准价不能为空',
        tax_rate_cannot_be_empty: '个税率不能为空',
        sales_price_cannot_be_empty: '个销售价不能为空',
        discount_ratio_cannot_be_empty: '个折扣比例不能为空',
        cnt_cannot_be_empty: '个数量不能为空',
        select_quote_no: '选择报价单号',
        quote_no_cannot_be_empty: '报价单号不能为空'
    },
    contract: {
        contract_remark: '合同备注',
        select_contract_template: '选择合同模板',
        contract_template_cannot_be_empty: '合同模板不能为空',
    },
    exam: {
        catalog: '知识技能类别',
        question_type: '题型',
        score: '每题分值',
        question_number: '题目数量',
        level: '难度'
    }

}